module.exports = __webpack_public_path__ + "img/menu1.ad5c7a26.png";